<template>
  <div>
    <px-view-header title="Cadastro de modos de pagamento"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"
                    default-title-column-size="8"
                    default-breadcrumbs-column-size="4">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loadingModoPagamento">
      <px-circular-loading/>
    </div>
    <v-container>
      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            outlined
            required
            hide-details
            maxlength="100"
            class="required rounded-tag-small"
            label="Descrição da forma de pagamento"
            :error="$v.modoPagamento.descricao.$error"
            @blur="$v.modoPagamento.descricao.$touch()"
            v-model="modoPagamento.descricao"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            outlined
            hide-details
            maxlength="50"
            class="rounded-tag-small"
            label="Código interno da forma de pagamento"
            v-model="modoPagamento.codigoInterno"
          />
        </v-col>
      </v-row>
      <div class="mt-5">
        <v-btn color="primary"
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="onClickSave"
               :loading="loading">
          Salvar
        </v-btn>
        <v-btn text class="normal-btn-text" @click="onClickBack">Cancelar</v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';
import ModoPagamentoService from './modos-pagamento-service';


export default {
  mixins: [validationMixin],
  data() {
    return {
      loading: false,
      loadingModoPagamento: false,
      modoPagamento: {
        descricao: null,
        codigoInterno: null,
      },
      modoPagamentoId: this.$route.params.id,
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Modos de pagamento' },
      ],
    };
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: 'main.modos-pagamento' });
    },
    getModoPagamento() {
      this.loadingModoPagamento = true;
      ModoPagamentoService.get(this.modoPagamentoId)
        .then((response) => {
          this.modoPagamento = response.data;
        })
        .finally(() => {
          this.loadingModoPagamento = false;
        });
    },
    buildPayload() {
      const modoPagamento = { ...this.modoPagamento };
      modoPagamento.descricao = this.modoPagamento.descricao.trim();
      if (this.modoPagamento.codigoInterno) {
        modoPagamento.codigoInterno = this.modoPagamento.codigoInterno.trim();
      }
      return modoPagamento;
    },
    salvar() {
      this.loading = true;
      ModoPagamentoService.save(this.buildPayload())
        .then(() => {
          if (this.modoPagamentoId) {
            this.$toast('Modo de pagamento atualizado com sucesso', { color: 'success' });
          } else {
            this.$toast('Modo de pagamento criado com sucesso', { color: 'success' });
          }
          this.onClickBack();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickSave() {
      if (this.validateForm()) {
        return;
      }
      this.salvar();
    },
  },
  created() {
    if (this.modoPagamentoId) {
      this.getModoPagamento();
    }
  },
  validations: {
    modoPagamento: {
      descricao: {
        required,
      },
    },
  },
};
</script>
